import Api from "../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Scala riport exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'scalaExport'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'printRow'
            },
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showDetails'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Sztornózás',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'stornoInvoice',
                additionalButtonVisible: "isNotCanceledInvoice"
            }
        ],
        searchFields: [
            {
                name: "patientName",
                label: "Páciens",
                formSize: 4,
                formVisible: true
            },
            {
                name: "siteId",
                label: "Ellátóhely",
                formVisible: true,
                formType: 'select',
                formSize: 4,
                selectOptions: {
                    apiCallback: Api.getAllCompanySite,
                    formatText: function (val) {
                        return val.siteName;
                    },
                    formatOption: function (val) {
                        return val.siteName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'siteName',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
                
            },
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 4,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            // { //nincs feü számlázás épp plusz az api se jó ide nagy valószínűséggel
            //     name: 'partnerId',
            //     label: 'Partner',
            //     formSize: 4,
            //     formType: 'select',
            //     selectOptions: {
            //         apiCallback: Api.getPartnersToSelect,
            //         formatText: function (val) {
            //             return val.text;
            //         },
            //         formatOption: function (val) {
            //             return val.text;
            //         },
            //         minimumInputLength: 0,
            //         searchOnServer: false,
            //         filteredAttr: 'text',
            //         returnValue: 'id',
            //         locale: {
            //             searchPlaceholder: 'Keresés...',
            //             noResults: 'Nincs találat'
            //         }
            //     }
            // },
            {
                name: 'invoiceTypeId',
                label: 'Számla típusa',
                formSize: 4,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getInvoiceTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "invoiceNumber",
                label: "Számlaszám",
                formSize: 4,
                formVisible: true,
            },
            {
                name: "dateOfCompletionFrom",
                label: "Teljesítés dátumától",
                formSize: 4,
                formType: "date",
                formVisible: true
            },
            {
                name: "dateOfCompletionTo",
                label: "Teljesítés dátumáig",
                formSize: 4,
                formType: "date",
                formVisible: true
            },
            {
                name: "createdOnFrom",
                label: "Kiállítás dátumától",
                formSize: 4,
                formType: "date",
                formVisible: true
            },
            {
                name: "createdOnTo",
                label: "Kiállítás dátumáig",
                formSize: 4,
                formType: "date",
                formVisible: true
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Számla ID",
                visibility: false
            },
            {
                name: "sitneName",
                label: "Ellátóhely",
                visibility: true
            },
            {
                name: "treatmentDate",
                label: "Kezelés dátuma",
                visibility: true,
                slot_name: "date_format"
            },
            {
                name: "itemName",
                label: "Kezelés",
                visibility: true
            },
            {
                name: "patientName",
                label: "Páciens",
                visibility: true
            },
            {
                name: "doctorName",
                label: "Orvos",
                visibility: true
            },
            // { //nincs feü számlázás épp
            //     name: "occupationHealthPartnerName",
            //     label: "Feü. partner",
            //     visibility: true
            // },
            {
                name: "customerName",
                label: "Vevő neve",
                visibility: true
            },
            {
                name: "insurancePartnerName",
                label: "Ellátásszervező",
                visibility: true
            },
            {
                name: "invoiceTypeName",
                label: "Számla típusa",
                visibility: true
            },
            {
                name: "canceled",
                label: "Sztornózott",
                visibility: true,
                slot_name: "stornoFormat"
            },
            {
                name: "invoiceNumber",
                label: "Számlaszám",
                visibility: true
            },
            {
                name: "dateOfCompletion",
                label: "Teljesítés dátuma",
                sort: true,
                visibility: true,
                slot_name: "productionTime_format"
            },
            {
                name: "paymentDeadline",
                label: "Fizetési határidő",
                sort: true,
                visibility: true,
                slot_name: "authenticationTime_format"
            },
            {
                name: "treatmentPrice",
                label: "Kezelés ára",
                visibility: true,
                slot_name: "currencyFormatByCurrencyType1"
            },
            {
                name: "net",
                label: "Nettó összeg",
                visibility: true,
                slot_name: "currencyFormatByCurrencyType2"
            },
            {
                name: "gross",
                label: "Bruttó összeg",
                visibility: true,
                slot_name: "currencyFormatByCurrencyType3"
            },
            {
                name: "paymentMethods",
                label: "Fizetési mód",
                visibility: true,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
